import TermsAndConditionsField from "./TermsAndConditionsField";
export default TermsAndConditionsField;
